export default __webpack_public_path__ + "static/media/iamsnext.50e999c7.svg";